var map = {
	"./BG@3x.png": "5201",
	"./banner.png": "269a",
	"./bg-coffee.png": "d4f6",
	"./bg-for-privacysetting.png": "caff",
	"./bg-profile-new.png": "bbe2",
	"./cart_icon.svg": "b6227",
	"./empty_cart.svg": "4c98",
	"./location_icon.svg": "b45d",
	"./logo-new-theme.png": "ff84",
	"./logo@3x.png": "edc7",
	"./menu_icon.svg": "ec80",
	"./ncf-logo@3x.png": "da2b",
	"./order_icon.svg": "b057",
	"./points.png": "17e5",
	"./qrcode.png": "090c",
	"./subscription_icon.svg": "4bc6",
	"./texture.svg": "8b5b",
	"./white_dropdown.svg": "5f9b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf13";